var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { deepmerge } from '@mui/utils';
import { createMuiAlertTitleOverrides } from '../alert/alert-title/alert-title-overrides';
import { createMuiAppBarOverrides } from '../app-bar/app-bar-overrides';
import { createMuiAutocompleteOverrides } from '../autocomplete/autocomplete-overrides';
import { createMuiBackdropOverrides } from '../backdrop/backdrop-overrides';
import { createMuiBadgeOverrides } from '../badge/badge-overrides';
import { createMuiBreadcrumbsOverrides } from '../breadcrumbs/breadcrumbs-overrides';
import { createMuiButtonOverrides } from '../button/button-overrides';
import { createMuiCardHeaderOverrides } from '../card/card-header/card-header-overrides';
import { createMuiCardOverrides } from '../card/card-overrides';
import { createMuiChipOverrides } from '../chip/chip-overrides';
import { createMuiCssBaselineOverrides } from '../css-baseline/css-baseline-overrides';
import { createMuiDialogActionsOverrides } from '../dialog/dialog-actions/dialog-actions-overrides';
import { createMuiDialogContentOverrides } from '../dialog/dialog-content/dialog-content-overrides';
import { createMuiDialogOverrides } from '../dialog/dialog-overrides';
import { createMuiDialogTitleOverrides } from '../dialog/dialog-title/dialog-title-overrides';
import { createMuiDividerOverrides } from '../divider/divider-overrides';
import { createMuiFormControlLabelOverrides } from '../form/form-control-label/form-control-overrides';
import { createMuiFormControlOverrides } from '../form/form-control/form-control-overrides';
import { createMuiFormHelperTextOverrides } from '../form/form-helper-text/form-helper-text-overrides';
import { createMuiFormLabelOverrides } from '../form/form-label/form-label-overrides';
import { createMuiIconButtonOverrides } from '../icon-button/icon-button-overrides';
import { createMuiInputAdornmentOverrides } from '../input/input-adornment/input-adornment-overrides';
import { createMuiInputBaseOverrides } from '../input/input-base-overrides';
import { createMuiInputLabelOverrides } from '../input/input-label/input-label-overrides';
import { createMuiListItemOverrides } from '../list/list-item/list-item-overrides';
import { createMuiListItemTextOverrides } from '../list/list-item-text/list-item-text-overrides';
import { createMuiListOverrides } from '../list/list-overrides';
import { createMuiListSubheaderOverrides } from '../list/list-subheader/list-subheader-overrides';
import { createMuiMenuItemOverrides } from '../menu/menu-item/menu-item-overrides';
import { createMuiMenuOverrides } from '../menu/menu-overrides';
import { createMuiOutlinedInputOverrides } from '../input/outlined-input-overrides';
import { createMuiRadioOverrides } from '../radio/radio-overrides';
import { createMuiTooltipOverrides } from '../tooltip/tooltip-overrides';
import { createMuiTypographyOverrides } from '../text/text-overrides';
import { createMuiCheckboxOverrides } from '../checkbox/checkbox-overrides';
import { createMuiSelectOverrides } from '../select/select-overrides';
import { createMuiSwitchOverrides } from '../switch/switch-overrides';
import { createMuiSnackbarOverrides } from '../toast/toast-overrides';
import { toggleButtonClasses } from '@mui/material/ToggleButton';
import { createMuiTextFieldOverrides } from '../text-field/text-field-overrides';
import { createMuiTabsOverrides } from '../tabs/tabs-overrides';
import { createMuiTabOverrides } from '../tabs/tab/tab-override';
import { createMuiTableOverrides } from '../table/table-overrides';
import { createMuiTableCellOverrides } from '../table/table-cell/table-cell-overrides';
import { createMuiTableContainerOverrides } from '../table/table-container/table-container-overrides';
import { createMuiTableRowOverrides } from '../table/table-row/table-row-overrides';
import { createMuiTableSortLabelOverrides } from '../table/table-sort-label/table-sort-label-overrides';
export var createComponents = function (_a) {
    var _b;
    var components = _a.components, options = __rest(_a, ["components"]);
    var defaultOptions = {
        MuiAlertTitle: createMuiAlertTitleOverrides(options),
        MuiAppBar: createMuiAppBarOverrides(options),
        MuiAutocomplete: createMuiAutocompleteOverrides(options),
        MuiBackdrop: createMuiBackdropOverrides(options),
        MuiBadge: createMuiBadgeOverrides(options),
        MuiBreadcrumbs: createMuiBreadcrumbsOverrides(options),
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
                disableTouchRipple: true,
            },
        },
        MuiButton: createMuiButtonOverrides(options),
        MuiButtonGroup: {
            defaultProps: {
                disableRipple: true,
                disableElevation: true,
            },
        },
        MuiCard: createMuiCardOverrides(options),
        MuiCardHeader: createMuiCardHeaderOverrides(options),
        MuiCheckbox: createMuiCheckboxOverrides(options),
        MuiChip: createMuiChipOverrides(options),
        MuiCssBaseline: createMuiCssBaselineOverrides(options),
        MuiDialog: createMuiDialogOverrides(options),
        MuiDialogActions: createMuiDialogActionsOverrides(options),
        MuiDialogContent: createMuiDialogContentOverrides(options),
        MuiDialogTitle: createMuiDialogTitleOverrides(options),
        MuiDivider: createMuiDividerOverrides(options),
        MuiFormControl: createMuiFormControlOverrides(options),
        MuiFormControlLabel: createMuiFormControlLabelOverrides(options),
        MuiFormHelperText: createMuiFormHelperTextOverrides(options),
        MuiFormLabel: createMuiFormLabelOverrides(options),
        MuiIconButton: createMuiIconButtonOverrides(options),
        MuiInputAdornment: createMuiInputAdornmentOverrides(options),
        MuiInputBase: createMuiInputBaseOverrides(options),
        MuiInputLabel: createMuiInputLabelOverrides(options),
        MuiList: createMuiListOverrides(options),
        MuiListItem: createMuiListItemOverrides(options),
        MuiListItemText: createMuiListItemTextOverrides(options),
        MuiListSubheader: createMuiListSubheaderOverrides(options),
        MuiMenu: createMuiMenuOverrides(options),
        MuiMenuItem: createMuiMenuItemOverrides(options),
        MuiOutlinedInput: createMuiOutlinedInputOverrides(options),
        MuiRadio: createMuiRadioOverrides(options),
        MuiSelect: createMuiSelectOverrides(options),
        MuiSnackbar: createMuiSnackbarOverrides(options),
        MuiSwitch: createMuiSwitchOverrides(options),
        MuiTable: createMuiTableOverrides(options),
        MuiTableCell: createMuiTableCellOverrides(options),
        MuiTableContainer: createMuiTableContainerOverrides(options),
        MuiTableRow: createMuiTableRowOverrides(options),
        MuiTableSortLabel: createMuiTableSortLabelOverrides(options),
        MuiTabs: createMuiTabsOverrides(options),
        MuiTab: createMuiTabOverrides(options),
        MuiTextField: createMuiTextFieldOverrides(options),
        MuiToggleButton: {
            styleOverrides: {
                root: (_b = {
                        borderColor: options.palette.neutral[200],
                        '& > *:first-child > svg': {
                            stroke: options.palette.neutral[900],
                        }
                    },
                    _b["".concat(toggleButtonClasses.selected)] = {
                        backgroundColor: options.palette.neutral[50],
                        '& > *:first-child > svg': {
                            stroke: options.palette.primary.main,
                        },
                    },
                    _b["".concat(toggleButtonClasses.disabled)] = {
                        '& > *:first-child > svg': {
                            stroke: options.palette.neutral[200],
                        },
                    },
                    _b),
                sizeSmall: {
                    minWidth: 'unset',
                    fontSize: options.typography.button.fontSize,
                    padding: options.spacing(1.25, 1.125),
                    '& > *:first-child': {
                        fontSize: '1rem',
                        height: '1em',
                        width: '1em',
                    },
                },
            },
        },
        MuiTooltip: createMuiTooltipOverrides(options),
        MuiTypography: createMuiTypographyOverrides(options),
    };
    return deepmerge(defaultOptions, typeof components === 'function' ? components(options) : components);
};
